import * as components from '../components';

const globalComponentRegistration = {
	install(Vue, options = {}) {
		// Register all components globally
		Object.keys(components).forEach(name => {
			Vue.component(name, components[name]);
		});
	}
};

export default globalComponentRegistration;